import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import Store, { persistor } from "./Redux/Store/Store";
import { PersistGate } from "redux-persist/integration/react";


import * as Sentry from "@sentry/react";



Sentry.init({
  dsn: "https://9b579de57506da21fd46ea9020bb63c6@o4510108262006784.ingest.us.sentry.io/4510108268101632",   
  
  tracesSampleRate: 1.0,      
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        
        <Sentry.ErrorBoundary fallback={<p>Something went wrong!</p>}>
          <App />
        </Sentry.ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
